/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { MYCUSTOMERS, MYPROJECTS, MYBROKERS, BROKERLISTWITHDRM } from './mutation-types';

export default {
  [MYCUSTOMERS](state, payload) {
    state.myCustomers = payload;
    // state.myBrokers = payload.broker_list;
  },

  [MYPROJECTS](state, payload) {
    state.myProjects = payload;
  },

  [MYBROKERS](state, payload) {
    state.myBrokers = payload;
  },

  [BROKERLISTWITHDRM](state, payload) {
    state.brokerListWithDrm = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/saleshead/mutations.js